// tslint:disable-next-line:eofline
export const ADMINISTRATION_USER_DASHBOARD: string= 'dashboard' ;
export const ADMINISTRATION_USER: string = 'users';
export const ADMINISTRATION_NEW_USER: string ='new-user';
export const ADMINISTRATION_CENTER_LIST: string ='centers';
export const ADMINISTRATION_USER_DETAIL: string = 'user-details';
export const ADMINISTRATION_CENTER_DETAILS: string ='center-details';
export const ADMINISTRATION_IMPORT_USERS: string ='import-users';
export const ADMINISTRATION_IMPORT_USERS_DISABLE: string ='import-users-disable';
